import { Link } from 'react-router-dom';

const plans = [
  {
    name: 'Starter',
    planId: 'starter',
    description: 'Perfect for solo agents and small teams just getting started with automation.',
    price: null,
    highlighted: false,
    features: [
      'AI Chat Assistant',
      'Up to 3 staff users',
      'WhatsApp automation (500 msgs/mo)',
      'CRM pipeline (up to 200 leads)',
      'Basic invoicing & quotes',
      'Email support',
    ],
  },
  {
    name: 'Growth',
    planId: 'pro',
    description: 'For growing agencies that want full automation across all channels.',
    price: null,
    highlighted: true,
    badge: 'Most Popular',
    features: [
      'Everything in Starter',
      'Up to 10 staff users',
      'WhatsApp automation (2,000 msgs/mo)',
      'Unlimited CRM leads',
      'Booking conversion system',
      'Lead capture forms',
      'Priority support',
    ],
  },
  {
    name: 'Pro',
    planId: 'enterprise',
    description: 'Enterprise-grade for high-volume agencies managing multiple brands or offices.',
    price: null,
    highlighted: false,
    features: [
      'Everything in Growth',
      'Unlimited users',
      'Unlimited WhatsApp messages',
      'Multi-branch support',
      'Custom AI training',
      'API access & integrations',
      'Dedicated account manager',
    ],
  },
];

export default function PricingSection() {
  return (
    <section id="pricing" className="py-24 md:py-32 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center max-w-xl mx-auto mb-16">
          <p className="text-sm font-medium uppercase tracking-wider mb-3 bg-gradient-to-r from-teal-500 to-indigo-500 bg-clip-text text-transparent">Pricing</p>
          <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 leading-tight tracking-tight">
            Simple, Scalable Pricing
          </h2>
          <p className="text-sm text-gray-500 mt-4 leading-relaxed">
            Built for agencies of all sizes with multi-user and multi-client support.
            <br />No hidden fees. Cancel anytime.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`relative rounded-xl p-7 border flex flex-col gap-5 transition-all ${
                plan.highlighted
                  ? 'bg-black border-black text-white'
                  : 'bg-white border-gray-100 text-gray-900'
              }`}
            >
              {plan.badge && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-teal-500 to-indigo-500 rounded-full px-3 py-0.5">
                  <span className="text-xs font-semibold text-white">{plan.badge}</span>
                </div>
              )}

              <div>
                <h3 className={`text-base font-semibold mb-1.5 ${plan.highlighted ? 'text-white' : 'text-gray-900'}`}>
                  {plan.name}
                </h3>
                <p className={`text-sm leading-relaxed ${plan.highlighted ? 'text-gray-300' : 'text-gray-500'}`}>
                  {plan.description}
                </p>
              </div>

              <div className="flex items-end gap-1">
                <span className={`text-2xl font-semibold ${
                  plan.highlighted
                    ? 'bg-gradient-to-r from-teal-400 to-indigo-400 bg-clip-text text-transparent'
                    : 'bg-gradient-to-r from-teal-500 to-indigo-500 bg-clip-text text-transparent'
                }`}>
                  Coming Soon
                </span>
              </div>

              <ul className="flex flex-col gap-2.5 flex-1">
                {plan.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-2.5 text-sm">
                    <i
                      className={`ri-check-line mt-0.5 shrink-0 ${
                        plan.highlighted ? 'text-teal-400' : 'text-teal-500'
                      }`}
                    />
                    <span className={plan.highlighted ? 'text-gray-200' : 'text-gray-600'}>{feature}</span>
                  </li>
                ))}
              </ul>

              <Link
                to={`/register?plan=${plan.planId}`}
                className={`text-sm font-medium py-2.5 rounded-md text-center transition-colors cursor-pointer whitespace-nowrap ${
                  plan.highlighted
                    ? 'bg-gradient-to-r from-teal-500 to-indigo-500 text-white hover:from-teal-400 hover:to-indigo-400'
                    : 'border border-gray-200 text-gray-700 hover:border-teal-300 hover:text-teal-600 hover:bg-teal-50/30'
                }`}
              >
                Start Free Trial
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}